<template>
    <ion-button
        class="delete-button"
        :button-type="props.buttonType"
        :color="props.color"
        :disabled="props.disabled"
        :download="props.download"
        :expand="props.expand"
        :fill="props.fill"
        :href="props.href"
        :mode="props.mode"
        :rel="props.rel"
        :router-animation="props.routerAnimation"
        :router-direction="props.routerDirection"
        :shape="props.shape"
        :size="props.size"
        :strong="props.strong"
        :target="props.target"
        :type="props.type"
    >
        <ion-icon icon="assets/icon/delete.svg"/>
    </ion-button>
</template>

<script setup lang="ts">
import { IonButton, IonIcon } from "@ionic/vue";

import { BUTTON_TYPE, ION_ROUTER_DIRECTION, ION_VARIANT } from "@/types/enum/ionicEnum";
import { IonButtonProps } from "@/types/props";

const props = withDefaults(defineProps<IonButtonProps>(), {
    buttonType: BUTTON_TYPE.BUTTON,
    color: ION_VARIANT.TRANSPARENT,
    disabled: false,
    routerDirection: ION_ROUTER_DIRECTION.FORWARD,
    strong: false,
    type: BUTTON_TYPE.BUTTON
})
</script>

<style scoped>
.delete-button.button-outline {
    --background: tranparent;
    --background-activated: transparent;
    --background-focues: transparent;
    --background-hover: transparent;
}

.delete-button.inherit-color::part(native) {
    color: inherit;
}

.delete-button.inherit-border-color::part(native) {
    border-color: var(--color);
}
</style>

<style scoped lang="scss">
@use '@/theme/mixin.scss';

.delete-button {
    --padding-start: 8px;
    --padding-end: 8px;
    --box-shadow: none;
    --ion-color-contrast: var(--ion-color-danger) !important;

    @include mixin.light {
        box-shadow: var(--light-shadow);
    }

    @include mixin.dark {
        box-shadow: none;
    }
}
</style>
